import * as React from 'react';

import {IBranding, IDocument, IDisclaimer, ProductLine} from '../../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../../infrastructure/placeholderTypes';
import { removeDuplicates } from '../../../../../../lib/helpers';
import { isUSA } from '../../../../../../config';

export interface IBackLayoutProps {
  document: IDocument | null;
  brandings: IBranding[];
  isEditorRendering: boolean;
  isWebPageCover: boolean;
  disclaimers: IDisclaimer[] | null;
}

export interface IBackLayoutState { }

export default class BackLayout extends React.Component<IBackLayoutProps, IBackLayoutState> {
  constructor(props: IBackLayoutProps) {
    super(props);
  }

  filterDisclaimers() {
    let disclaimers: Array<any> = [];
    this.props.document!.pages.forEach((page) => {
      if (page) {
        page.placeholders.forEach((placeholder) => {
          if (placeholder.type === placeholderTypes.Product && placeholder.data
            && this.props.document!.type !== 'Catalog') {
            disclaimers.push(...placeholder.data.disclaimers!);
          }
        });
      }
    });

    disclaimers = removeDuplicates(disclaimers, 'value');
    return disclaimers;
  }

  render() {
      const isDynaGroCover = (!!this.props.document) && (!!this.props.document.coverImage) && (this.props.document!.coverImage!.coverType == ProductLine.SEED);
      switch (this.props.document!.type) {
          case 'Catalog': {
              return isDynaGroCover
              ? (isUSA() ? this.renderDynaGroCatalogCover() : this.renderProvenCatalogCover())
              : this.renderLovelandCatalogCover();
          }
          case 'Brochure': {
              return isDynaGroCover
              ? (isUSA() ? this.renderDynaGroBrochureCover() : this.renderProvenBrochureCover())
              : this.renderLovelandBrochureCover();
          }
          case 'Postcard': {
            return this.renderPostcardBack();
          }
      }
      return (<div></div>);
  }

  renderDynaGroCatalogCover() {
      const {
          document,
          isWebPageCover,
      } = this.props;

      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }
      const firstLogo = document!.logos[0];

      return (
          <div className="back-cover-page" >
              <img
                  className="cover-page"
                  src={
                    isWebPageCover
                          ? document!.coverImage!.web.backCover
                          : document!.coverImage!.print.fullCover
                  }
                  alt={document!.coverImage!.title}
              />

              {
                  document.companyInfo.isEnabled ?
                      <div className="division-name-dyna-gro-catalog">
                          <p className="label">
                              {document.companyInfo.divisionName}
                          </p>
                          <p className="label">
                              {document.companyInfo.phoneNumber}
                          </p>
                          <p className="label">
                              {document.companyInfo.email}
                          </p>
                      </div> : null
              }

              <div className="back-branding-dyna-gro-catalog">
                  {firstLogo ?
                      (<img
                          key={firstLogo.id}
                          alt={firstLogo.title}
                          src={firstLogo.image}
                      />) : null
                  }
              </div>
          </div >
      );
  }

  renderProvenCatalogCover() {
      const {
          document,
          isWebPageCover,
      } = this.props;
  
      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }
      {/* const firstLogo = document!.logos[0]; */}
  
      return (
          <div className="back-cover-page" >
              <img
                  className="cover-page"
                  src={
                    isWebPageCover
                          ? document!.coverImage!.web.backCover
                          : document!.coverImage!.print.fullCover
                  }
                  alt={document!.coverImage!.title}
              />
  
              {
                  document.companyInfo.isEnabled ?
                      <div className="division-name-proven-catalog">
                          <p className="label">
                              {document.companyInfo.divisionName}
                          </p>
                          <p className="label">
                              {document.companyInfo.phoneNumber}
                          </p>
                          <p className="label">
                              {document.companyInfo.email}
                          </p>
                      </div> : null
              }
          </div >
      );
  }

  renderLovelandCatalogCover() {
      const {
          document,
          isEditorRendering,
          isWebPageCover,
      } = this.props;
      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }

      const disclaimers = this.filterDisclaimers();
      const year = new Date().getFullYear();
      const firstLogo = document.logos[0];

      return (
          <div className="back-cover-page" >
              <img
                  className="cover-page"
                  src={
                    isWebPageCover
                          ? document!.coverImage!.web.backCover
                          : document!.coverImage!.print.fullCover
                  }
                  alt={document!.coverImage!.title}
              />
              <div className="disclaimers">
                  {
                      disclaimers ?
                          disclaimers.filter(d => d.value !== '#').map((el, i) => {
                            return (
                              <div key={i}>
                                <p dangerouslySetInnerHTML={{ __html: el.description }}></p>
                              </div>
                            );
                          }) :
                          null
                  }
              </div>
              <div className="back-branding-loveland-catalog">
                  {
                      isEditorRendering ?
                          this.props.brandings &&
                          this.props.brandings.map(brand => <img key={brand.id} src={brand.coverImage} alt={brand.title} />) :
                          this.props.brandings
                              .filter(b => b.title !== 'Nutrien Wholesale')
                              .map(brand => <img key={brand.id} src={brand.coverImage} alt={brand.title} />)
                  }

              </div>
              <div className="back-logo-loveland-catalog">
                  {
                    firstLogo
                      ? <img key={firstLogo.id} src={firstLogo.image} alt={firstLogo.title} />
                      : null
                  }

              </div>

              <div className="copyright-loveland-catalog">
                  <p>
                    LOVELAND PRODUCTS, INC.®<br/>
                    P.O. BOX 1286 | GREELEY, CO 80632<br/>
                    www.LovelandProducts.com
                  </p>
                  <p>
                    <b>ALWAYS READ AND FOLLOW LABEL DIRECTIONS.</b>
                  </p>
                  <p>
                    {"© " + year + " Loveland Products, Inc. All Rights Reserved."}<br/>
                    All of the trademarks and service marks displayed are marks of their respective owners.<br/>
                    Check State Registration to make sure product is registered in your state.
                  </p>
              </div>
          </div>
      );
  }

  renderDynaGroBrochureCover() {
      const {
          document,
          isWebPageCover,
      } = this.props;

      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }

      const firstLogo = document!.logos[0];
      const disclaimers = this.filterDisclaimers();
      return (
          <div className="back-cover-page" >
              <img
                  className="cover-page"
                  src={
                    isWebPageCover
                    ? document!.coverImage!.web.backCover
                    : document!.coverImage!.print.fullCover
                  }
                  alt={document!.coverImage!.title}
               />

              {
                  document.companyInfo.isEnabled ?
                      <div className="division-name-dyna-gro-brochure">
                          <p className="label">
                              {document.companyInfo.divisionName}
                          </p>
                          <p className="label">
                              {document.companyInfo.phoneNumber}
                          </p>
                          <p className="label">
                              {document.companyInfo.email}
                          </p>
                      </div> : null
              }

              <div className="back-branding-dyna-gro-brochure">
                  { firstLogo ?
                      (<img
                              key={firstLogo.id}
                              alt={firstLogo.title}
                              src={firstLogo.image}
                      />) : null
                  }
              </div>

              <div className="disclaimers-dyna-gro">
                  {
                      disclaimers ? disclaimers.filter(d => d.value !== '#').map((el, i) => {
                              return (
                                  <div key={i}>
                                      <p dangerouslySetInnerHTML={{ __html: el.description}}></p>
                                  </div>
                              );
                          }) :
                          null
                  }
              </div>
          </div >
      );
  }

  renderProvenBrochureCover() {
      const {
          document,
          isWebPageCover,
      } = this.props;
  
      if ((document == undefined) || (document.coverImage == undefined)) {
          return (<div></div>);
      }

      const disclaimers = this.filterDisclaimers();
      return (
          <div className="back-cover-page" >
              <img
                  className="cover-page"
                  src={
                    isWebPageCover
                    ? document!.coverImage!.web.backCover
                    : document!.coverImage!.print.fullCover
                  }
                  alt={document!.coverImage!.title}
               />
  
              {
                  document.companyInfo.isEnabled ?
                      <div className="division-name-proven-brochure">
                          <p className="label">
                              {document.companyInfo.divisionName}
                          </p>
                          <p className="label">
                              {document.companyInfo.phoneNumber}
                          </p>
                          <p className="label">
                              {document.companyInfo.email}
                          </p>
                      </div> : null
              }
  
              <div className="disclaimers-proven-brochure">
                {
                    disclaimers ? disclaimers.filter(d => d.value !== '#').map((el, i) => {
                            return (
                                <div key={i}>
                                    <p dangerouslySetInnerHTML={{ __html: el.description}}></p>
                                </div>
                            );
                        }) :
                        null
                }
              </div>
          </div >
      );
  }

  renderLovelandBrochureCover() {
    const {
      document,
      isEditorRendering,
      isWebPageCover,
    } = this.props;

    const disclaimers = this.filterDisclaimers();
    if ((document == undefined) || (document.coverImage == undefined)) {
        return (<div></div>);
    }
    const firstLogo = document!.logos[0];

    return (
      <div className="back-cover-page" >
        <img
          className="cover-page"
          src={
            isWebPageCover
              ? document!.coverImage!.web.backCover
              : document!.coverImage!.print.fullCover
          }
          alt={document!.coverImage!.title}
        />
        <div className="logos-list-loveland-brochure">
          {firstLogo ?
              (<img
                  key={firstLogo.id}
                  alt={firstLogo.title}
                  src={firstLogo.image}
              />) : null
          }
        </div>
          {
              document.companyInfo.isEnabled ?
                  <div className="division-name-loveland-brochure">
                      <p className="label">
                          {document.companyInfo.divisionName}
                      </p>
                      <p className="label">
                          {document.companyInfo.phoneNumber}
                      </p>
                      <p className="label">
                          {document.companyInfo.email}
                      </p>
                  </div> : null
          }
        <div className="disclaimers-loveland-brochure">
          {
            disclaimers ? disclaimers.filter(d => d.value !== '#').map((el, i) => {
              return (
                <div key={i}>
                  {/* <span>{el.value}</span> */}
                  <p dangerouslySetInnerHTML={{ __html: el.description }}></p>
                </div>
              );
            }) :
              null
          }
        </div>
        <div className="brandings-list-loveland-brochure">
          {
            isEditorRendering ?
              this.props.brandings &&
              this.props.brandings.map(brand => <img key={brand.id} src={brand.coverImage} alt={brand.title} />) :
              this.props.brandings
                .filter(b => b.title !== 'Nutrien Wholesale')
                .map(brand => <img key={brand.id} src={brand.coverImage} alt={brand.title} />)
          }

        </div>
      </div >
    );
  }

  renderPostcardBack() {
    const {
        document,
    } = this.props;

    const disclaimers = this.filterDisclaimers();

    if ((document == undefined) || (document.postcardImageBack == undefined)) {
        return (<div></div>);
    }

    return (
        <div className="back-cover-postcard-container">

              <div className="postcard-back-additional-text-container">
                    {
                        document!.additionalInfo.isEnabled ?
                            <div className="additional-info-back-postcard">
                                <div className="additional-text-back-poster">{document!.additionalInfo.text}</div>
                            </div> : null
                    }
              </div>
              <div className="postcard-back-additional-text-container">
                    {
                        document!.companyInfo.isEnabled?
                            <div className="contact-info-back-postcard">
                                <div className="divisionName-text-back-poster">{document!.companyInfo.divisionName}</div>
                                <div className="email-text-back-poster">{document!.companyInfo.email}</div>
                                <div className="phoneNumber-text-back-poster">{document!.companyInfo.phoneNumber}</div>
                            </div> : null
                    }
              </div>
              <div className="disclaimers-postcard">
                    {
                      disclaimers ? disclaimers.filter(d => d.value !== '#').map((el, i) => {
                        return (
                          <div key={i}>
                            <p dangerouslySetInnerHTML={{ __html: el.description }}></p>
                          </div>
                        );
                      }) :
                        null
                    }
              </div>
              <img className="postcard-image-container" src={ document.postcardImageBack.image_src } />
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/BackLayout/BackLayout.tsx